export default __webpack_public_path__ + "static/media/disk.c1915a37.png";